<template>
  <header class="blog-mobile-header" role="banner">
    <div class="blog-mobile-header__row">
      <router-link to="/portal-zinnes" class="blog-mobile-header__brand" aria-label="Portal Zinnes">
        <img src="@/assets/images/Rectangle 3.png" alt="Zinnes" class="blog-mobile-header__logo" width="72" height="24" />
      </router-link>

      <div class="blog-mobile-header__actions">
        <button
          type="button"
          class="blog-mobile-header__icon-btn"
          :aria-expanded="searchOpen ? 'true' : 'false'"
          aria-label="Buscar matérias"
          @click="toggleSearch"
        >
          <v-icon color="#ffffff" small>mdi-magnify</v-icon>
        </button>
      </div>
    </div>

    <div v-if="searchOpen" class="blog-mobile-header__search" :class="{ 'blog-mobile-header__search--open': searchOpen }">
      <form role="search" @submit.prevent="submitSearch">
        <label class="sr-only" for="blog-mobile-search">Buscar matérias do blog</label>
        <v-icon class="blog-mobile-header__search-icon" small>mdi-magnify</v-icon>
        <input
          id="blog-mobile-search"
          ref="searchInput"
          v-model="term"
          type="search"
          maxlength="80"
          autocomplete="off"
          placeholder="Buscar matérias…"
          @input="onInput"
        />
        <button v-if="term" type="button" class="blog-mobile-header__clear" aria-label="Limpar busca" @click="clearSearch">Limpar</button>
      </form>
    </div>
  </header>
</template>

<script>
export default {
  name: "BlogHeaderMobile",
  props: {
    query: { type: String, default: "" },
  },
  data: () => ({ term: "", searchOpen: false, debounceTimer: null }),
  watch: {
    query(value) {
      if (this.term !== value) this.term = value || "";
    },
  },
  methods: {
    toggleSearch() {
      this.searchOpen = !this.searchOpen;
      if (this.searchOpen) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) this.$refs.searchInput.focus();
        });
        if (this.term) this.$emit("search", this.term);
      }
    },
    onInput() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.$emit("search", this.term), 250);
    },
    submitSearch() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.$emit("search", this.term);
    },
    clearSearch() {
      this.term = "";
      this.$emit("search", "");
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },
};
</script>
